import { space } from '@atlaskit/editor-common/keymaps';
import type { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { PMPluginFactoryParams } from '@atlaskit/editor-common/src/types';
import { hasDocAsParent, isEmptyDocument, isEmptyParagraph } from '@atlaskit/editor-common/utils';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { fg } from '@atlaskit/platform-feature-flags';

import type { AIGlobalOptIn, EditorPluginAIProvider } from '../../types/types';
import { createOpenAIModalCommand } from '../decoration/actions';

export function createSpaceShortcutPlugin(options: {
	aiGlobalOptIn: AIGlobalOptIn;
	editorPluginAIProvider: EditorPluginAIProvider;
	getIntl: PMPluginFactoryParams['getIntl'];
}): SafePlugin {
	return keymap({
		[`${space.common}`]: (state, dispatch, view) => {
			if (!view) {
				return false;
			}

			const { from, to, $to } = state.selection;
			if (
				fg('platform_editor_ai_aifc_patch_beta_2')
					? from === to && isEmptyParagraph($to.parent) && hasDocAsParent($to)
					: isEmptyDocument(state.doc)
			) {
				const { editorPluginAIProvider, aiGlobalOptIn } = options;
				const configItem = editorPluginAIProvider.baseGenerate;

				const openAIModalCommand = createOpenAIModalCommand({
					state,
					configItem,
					lastTriggeredFrom: 'shortcut',
					triggerMethod: 'shortcut',
					aiGlobalOptIn: aiGlobalOptIn,
					locale: options.getIntl().locale,
				});

				openAIModalCommand(state, dispatch);
				return true;
			}

			return false;
		},
	}) as SafePlugin;
}
